const algoliaAppId = 'SBB2JYOIP1'
const algoliaApiKey = '2e4ef2c0e1206644aa681249dc8970c9'
const productSearchIndex = 'product_search'
const productSearchSuggestionsIndex = 'product_search_query_suggestions'
const boatSearchIndex = 'boat_search'
const boatSearchSuggestionsIndex = 'boat_search_query_suggestions'

export {
  algoliaAppId,
  algoliaApiKey,
  productSearchIndex,
  productSearchSuggestionsIndex,
  boatSearchIndex,
  boatSearchSuggestionsIndex,
}
